<template>
  <table>
    <tbody>
      <tr>
        <td>
          <span style='font-weight: 500;margin-left: 20px'>{{$ts('Alarm.cause')}}: </span>{{data.cause}}
        
          <span style='font-weight: 500;margin-left: 20px'>{{$ts('Alarm.advise')}}: </span>{{data.advise}}
        
          <span style='font-weight: 500;margin-left: 20px'>{{$ts('Alarm.xxdwinfo1')}}: </span>{{data.xxdwinfo1}}
        
          <span style='font-weight: 500;margin-left: 20px'>{{$ts('Alarm.xxdwinfo2')}}: </span>{{data.xxdwinfo2}}
        </td>
      </tr>
      <tr>
        <td>
          <span style='font-weight: 500;margin-left: 20px'>{{$ts('Alarm.xxkzinfo1')}}: </span>{{data.xxkzinfo1}}
        
          <span style='font-weight: 500;margin-left: 20px'>{{$ts('Alarm.xxkzinfo2')}}: </span>{{data.xxkzinfo2}}
        
          <span style='font-weight: 500;margin-left: 20px'>{{$ts('Alarm.xxkzinfo3')}}: </span>{{data.xxkzinfo3}}
        
          <span style='font-weight: 500;margin-left: 20px'>{{$ts('Alarm.xxkzinfo4')}}: </span>{{data.xxkzinfo4}}
        </td>
      </tr>
      <tr>
        <td>
          <span style='font-weight: 500;margin-left: 20px'>{{$ts('Alarm.confirmUser')}}: </span>{{data.confirmUser}}
        
          <span style='font-weight: 500;margin-left: 20px'>{{$ts('Alarm.confirmTime')}}: </span>{{data.createTimeFormat}}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import i18n from '../../plugins/i18n';

export default {
  name: 'DetailTemp',
  data(){
    return {
      data:{}
    }
  },
  methods: {
    $ts(args) {
      const mes = args.split('.');
      const result = (mes[0] && mes[1] && i18n.messages[i18n.locale][mes[0]][mes[1]]) ? i18n.messages[i18n.locale][mes[0]][mes[1]] : args;
      return result;
    }
  }
}
</script>
